var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "viewport",
          rawName: "v-viewport",
          value: _vm.onViewportIntersection,
          expression: "onViewportIntersection",
        },
      ],
      staticClass: "rb-algolia-editorial-products",
    },
    [
      _c("rb-algolia-base-editorial-products", {
        attrs: {
          "data-element-id": _vm.dataElementId,
          "internal-content": _vm.internalContent,
          products: _vm.products,
          "wishlist-icon-is-visible": _vm.wishlistIconIsVisible,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }